export default "__VITE_ASSET__B6MukhO8__"